// Admin-only Operator Console route — Phase 2C.
// In live mode (REACT_APP_OPS_CONSOLE_LIVE=true), uses real bearer-JWT auth
// against the ShelfLife platform_superadmin role. Otherwise falls back to
// the legacy mock auth so the prototype remains explorable without a backend.
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { LoginScreen } from "./auth/LoginScreen";
import { OperatorConsoleShell } from "./OperatorConsoleShell";
import { isLiveMode } from "./api/platformClient";
import { MockAuthProvider } from "./MockAuth";
import { AdminRouteGuard } from "./AdminRouteGuard";

const LiveGate = () => {
  const { isAuthenticated, isSuperadmin, user, logout } = useAuth();
  if (!isAuthenticated) return <LoginScreen />;
  if (!isSuperadmin) {
    return (
      <div
        data-testid="operator-console-role-denied"
        className="min-h-screen flex items-center justify-center bg-slate-50 p-6"
      >
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-8 shadow-sm text-center">
          <h1 className="text-xl font-semibold text-slate-900">
            403 — platform_superadmin required
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Signed in as <span className="font-medium">{user?.email}</span>. This
            console is restricted to <span className="font-mono">platform_superadmin</span>.
          </p>
          <button
            type="button"
            onClick={logout}
            data-testid="role-denied-signout"
            className="mt-5 inline-flex items-center gap-1 rounded-lg bg-[#0d3b66] text-white px-4 py-2 text-sm font-semibold hover:bg-[#0a2e52]"
          >
            Sign out
          </button>
        </div>
      </div>
    );
  }
  return <OperatorConsoleShell />;
};

export const OperatorConsolePage = () => {
  if (isLiveMode()) {
    return (
      <AuthProvider>
        <LiveGate />
      </AuthProvider>
    );
  }
  // Legacy mock-only path
  return (
    <MockAuthProvider>
      <AdminRouteGuard>
        <OperatorConsoleShell />
      </AdminRouteGuard>
    </MockAuthProvider>
  );
};

export default OperatorConsolePage;
